document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq-new__item');

  items.forEach(item => {
    const btn = item.querySelector('.faq-new__label');
    btn.addEventListener('click', () => {
      items.forEach(i => {
        if (i !== item) i.classList.remove('is-open');
      });
      item.classList.toggle('is-open');
    });
  });
});
